import { render, staticRenderFns } from "./ToContractButton.vue?vue&type=template&id=1b64ed9d&scoped=true"
import script from "./ToContractButton.vue?vue&type=script&lang=js"
export * from "./ToContractButton.vue?vue&type=script&lang=js"
import style0 from "./ToContractButton.vue?vue&type=style&index=0&id=1b64ed9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b64ed9d",
  null
  
)

export default component.exports